import { useState } from 'react';
import { voices } from '@/mocks/voices';
import SectionHeading from '@/pages/home/components/SectionHeading';

const avatarTones = [
  'bg-primary-500 text-background-50',
  'bg-foreground-950 text-background-50',
  'bg-accent-500 text-foreground-950',
  'bg-secondary-600 text-background-50',
];

export default function VoiceWall() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');
  const [notice, setNotice] = useState('');

  const toggleLike = (id: string, base: number) => {
    void base;
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePost = () => {
    if (!draft.trim()) {
      setNotice('先写点什么再发布吧');
      return;
    }
    setNotice('已记录你的观点（演示环境，暂不对外提交）');
    setDraft('');
  };

  return (
    <section id="voices" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          kicker="Reader Voices"
          title="读者热评 · 逻辑比情绪更值得被顶上去"
          description="这里没有统一的立场，只有对时间线、报价单和结算路径的追问与补充。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
            {voices.map((voice, index) => (
              <article
                key={voice.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-sm font-bold ${
                      avatarTones[index % avatarTones.length]
                    }`}
                  >
                    {voice.name.slice(0, 1)}
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-medium text-foreground-950">{voice.name}</p>
                    <p className="text-[11px] text-foreground-500">{voice.time}</p>
                  </div>
                  <span className="ml-auto shrink-0 rounded bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900">
                    {voice.tag}
                  </span>
                </div>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{voice.text}</p>
                <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <button
                    type="button"
                    onClick={() => toggleLike(voice.id, voice.likes)}
                    className={`flex items-center gap-1.5 whitespace-nowrap transition-colors ${
                      liked[voice.id] ? 'text-primary-600' : 'hover:text-primary-600'
                    }`}
                  >
                    <i className={liked[voice.id] ? 'ri-heart-3-fill text-sm' : 'ri-heart-3-line text-sm'} />
                    {voice.likes + (liked[voice.id] ? 1 : 0)}
                  </button>
                  <span className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-foreground-900">
                    <i className="ri-chat-3-line text-sm" />
                    回复
                  </span>
                  <span className="ml-auto flex cursor-pointer items-center gap-1.5 transition-colors hover:text-foreground-900">
                    <i className="ri-more-line text-base" />
                  </span>
                </div>
              </article>
            ))}
          </div>

          <div className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:sticky lg:top-24">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-chat-smile-2-line text-lg text-primary-500" />
                说两句
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                补充你知道的时间点或细节，我们会把它并入后续的时间线整理。
              </p>
              <textarea
                value={draft}
                onChange={(event) => {
                  setDraft(event.target.value);
                  setNotice('');
                }}
                maxLength={200}
                rows={5}
                placeholder="补充一个时间点、一份报价，或一句反驳……"
                className="mt-4 w-full resize-none rounded-md border border-background-300 bg-background-50 p-3 text-sm leading-relaxed text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
              <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-shield-line" />
                  发布前会自动脱敏
                </span>
                <span>{draft.length}/200</span>
              </div>
              <button
                type="button"
                onClick={handlePost}
                className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line text-base" />
                发布观点
              </button>
              {notice ? (
                <p className="mt-3 rounded-md bg-accent-100 px-3 py-2 text-xs text-accent-900">{notice}</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}